import { colors } from './colors';

const breakpoints = ['868px', '1024px', '1200px', '1634px'] as string[] & {
    sm: string;
    md: string;
    lg: string;
    xl: string;
};
breakpoints.sm = breakpoints[0];
breakpoints.md = breakpoints[1];
breakpoints.lg = breakpoints[2];
breakpoints.xl = breakpoints[3];

const themeDefinition = {
    colors,
    space: {
        0: '0px',
        2: '2px',
        4: '4px',
        6: '6px',
        8: '8px',
        12: '12px',
        16: '16px',
        24: '24px',
        32: '32px',
        40: '40px',
        48: '48px',
        56: '56px',
        64: '64px',
    },
    fontSizes: {
        10: '10px',
        12: '12px',
        14: '14px',
        20: '20px',
        24: '24px',
        32: '32px',
        48: '48px',
    },
    lineHeights: {
        0: '0px',
        14: '14px',
        18: '18px',
        26: '26px',
        32: '32px',
        40: '40px',
        64: '64px',
    },
    fontWeights: {
        400: 400,
        500: 500,
        600: 600,
        700: 700,
    },
    sizes: {
        0: '0px',
        2: '2px',
        4: '4px',
        8: '8px',
        16: '16px',
        24: '24px',
        32: '32px',
    },
    radii: {
        0: '0px',
        4: '4px',
        6: '6px',
        8: '8px',
        16: '16px',
    },
    borders: {
        default: '1px solid #edeff0',
    },
    shadows: {
        // Elevation shadows (for cards, modals, tooltips, etc.)
        small: '0px 1px 2px 1px rgba(25, 54, 67, 0.10)',
        medium: '0px 4px 8px -1px rgba(25, 54, 67, 0.15)',
        large: '0px 8px 24px -2px rgba(25, 54, 67, 0.20)',
        extraLarge: '0px 12px 24px -4px rgba(25, 54, 67, 0.30)',

        focus: `0px 0px 0px 3px ${colors.effects.focus}`,

        // Border shadows (simulating borders using box-shadow)
        border: {
            default: `0px 0px 0px 1px ${colors.border.muted}`,
            disabled: `0px 0px 0px 1px ${colors.foreground.disabled}`,
            negative: `0px 0px 0px 1px ${colors.negative.foreground}`,
            positive: `0px 0px 0px 1px ${colors.positive.foreground}`,
        },

        // Select/ComboBox shadows
        select: {
            base: '0px 0px 0px 0px rgba(6, 89, 255, 0), 0px 1px 1px 0px rgba(25, 54, 67, 0.16), 0px 2px 4px 0px rgba(25, 54, 67, 0.08), 0px 4px 8px 0px rgba(25, 54, 67, 0)',
            hover: '0px 0px 0px 0px rgba(6, 89, 255, 0.50), 0px 1px 1px 0px rgba(25, 54, 67, 0.16), 0px 2px 4px 0px rgba(25, 54, 67, 0.08), 0px 4px 8px 0px rgba(25, 54, 67, 0.08)',
        },
    },
    maxContentWidths: {
        regular: '1440px',
        wide: '1980px',
    },
    zIndex: {
        base: 0,
        100: 100,
        200: 200,
        300: 300,
        400: 400,
        500: 500,
        topbar: 2000,
        sidebar: 2001,
        overlay: 4000,
        overlayHeader: 4100,
        drawer: 4500,
        modalBackdrop: 5000,
        modal: 5100,
        interactive: 6000, // Like Tooltip, ComboBox, Popover, Dropdowns etc.
        toast: 7000,
        shortcutMenu: 7000,
        devTools: 10000,
    },
    breakpoints,
} as const;

export const theme = themeDefinition;
